var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "29",
      "height": "28"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M.75 28V0h28v28z"
    }
  }), _c('g', {
    attrs: {
      "fill": "#FFF"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.764 6.014h4.564v4.564H6.764zM4.483 12.86h9.126V3.733H4.483zm2.281 4.562h4.564v4.564H6.764zm-2.281 6.845h9.126v-9.126H4.483zm18.253-13.689h-4.564V6.014h4.564zM15.89 3.733v9.126h9.126V3.733zm9.124 18.248h-2.283v2.283h2.283zm-6.839-6.839h-2.283v2.283h2.283zm2.283 2.283h-2.283v2.283h2.283z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.175 19.708h-2.283v2.273h2.283zm2.283 2.273h-2.283v2.283h2.283zm2.273-2.273h-2.273v2.273h2.273zm0-4.566h-2.273v2.283h2.273z"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.014 17.425h-2.283v2.283h2.283z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }